"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _material = require("@mui/material");

var _TextButton = _interopRequireDefault(require("../TextButton/TextButton.overrides"));

var _Icon = require("../Icon");

var _Tooltip = require("../Tooltip");

var _utilities = require("../../utilities");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["text", "disabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledMuiIconButton = (0, _material.styled)(_material.IconButton)(function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  return _ref2 = {}, (0, _defineProperty2.default)(_ref2, "&.".concat(_utilities.classes.states.MuiFocusVisible), _TextButton.default.MuiButton.root["&.".concat(_utilities.classes.states.MuiFocusVisible)]), (0, _defineProperty2.default)(_ref2, "&:disabled", {
    backgroundColor: "transparent",
    borderColor: "transparent",
    color: theme.palette.brand.grey.stone,
    cursor: "not-allowed",
    pointerEvents: "initial"
  }), (0, _defineProperty2.default)(_ref2, "&:hover, &:focus, &:active", {
    "&:enabled": {
      "& .far": {
        fontWeight: 700
      },
      backgroundColor: "rgba(0, 0, 0, 0.14)",
      borderColor: "transparent",
      color: theme.palette.primary.main
    }
  }), (0, _defineProperty2.default)(_ref2, "borderColor", "transparent"), (0, _defineProperty2.default)(_ref2, "color", theme.palette.brand.grey.charcoal), _ref2;
});

var ToggleTip = function ToggleTip(_ref3) {
  var text = _ref3.text,
      _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
      rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.Tooltip, {
    open: open,
    title: text,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledMuiIconButton, _objectSpread(_objectSpread({}, rest), {}, {
      disabled: disabled,
      focusRipple: false,
      onBlur: function onBlur() {
        return setOpen(false);
      },
      onFocus: function onFocus() {
        return setOpen(true);
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        iconName: "question-circle",
        size: "medium"
      })
    }))
  });
};

var _default = ToggleTip;
exports.default = _default;